/* NX1 PROJECT | Glaze | product page, bundle builder, timeline. No dependencies. */
(function () {
  'use strict';
  var fmt = function (cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  };

  function addToCart(items, button, errorEl) {
    if (button) { button.disabled = true; button.dataset.label = button.dataset.label || button.textContent; button.textContent = '…'; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        if (window.NX1Cart) {
          if (button) { button.disabled = false; button.textContent = button.dataset.label; }
          return window.NX1Cart.open(true);
        }
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        if (button) { button.disabled = false; button.textContent = button.dataset.label; }
      });
  }

  /* ---------- Product page ---------- */
  function initPdp(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var dataEl = root.querySelector('[data-nx-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var currency = data.currency;
    var current = data.variants.filter(function (v) { return v.id === data.selected; })[0] || data.variants[0];
    var idInput = root.querySelector('[data-nx-variant-id]');
    var errorEl = root.querySelector('[data-nx-error]');
    var mainImg = root.querySelector('[data-nx-main-img]');

    function priceFor(offer, variant) {
      var qty = parseInt(offer.dataset.qty, 10) || 1;
      var full = variant.price * qty;
      var fixed = parseFloat(offer.dataset.total);
      var pct = parseFloat(offer.dataset.discount) || 0;
      var total = !isNaN(fixed) && fixed > 0 ? Math.round(fixed * 100) : Math.round(full * (1 - pct / 100));
      var compare = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price * qty : full;
      return { qty: qty, total: total, compare: compare > total ? compare : null };
    }

    function renderOffers() {
      root.querySelectorAll('[data-nx-offer]').forEach(function (offer) {
        var p = priceFor(offer, current);
        var days = parseFloat(root.dataset.days) || 42;
        var per = p.total / p.qty;
        offer.querySelector('[data-nx-offer-price]').innerHTML = fmt(p.total, currency) + (p.compare ? ' <s>' + fmt(p.compare, currency) + '</s>' : '');
        var unit = offer.querySelector('[data-nx-offer-unit]');
        if (unit) unit.textContent = (p.qty > 1 ? fmt(per, currency) + ' ' + (root.dataset.perLabel || 'per balm') + ' · ' : '') + fmt(per / days, currency) + ' ' + (root.dataset.dayLabel || 'a day');
        offer.querySelectorAll('select[data-nx-slot]').forEach(function (s) { if (!s.dataset.touched) s.value = String(current.id); });
      });
      var active = root.querySelector('[data-nx-offer].is-active');
      var priceEl = root.querySelector('[data-nx-price]');
      if (priceEl) {
        var cmp = current.compare_at_price && current.compare_at_price > current.price ? current.compare_at_price : null;
        priceEl.innerHTML = fmt(current.price, currency) + (cmp ? ' <s>' + fmt(cmp, currency) + '</s>' : '');
      }
    }

    function setVariant(v) {
      current = v;
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-nx-swatch]').forEach(function (b) { var on = String(b.dataset.nxSwatch) === String(v.id); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-nx-selected-name]').forEach(function (el) { el.textContent = v.title; });
      if (mainImg && v.image) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); }
      var atc = root.querySelector('[data-nx-atc]');
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? atc.dataset.addLabel : atc.dataset.soldLabel; }
      if (window.history && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
      renderOffers();
    }

    root.querySelectorAll('[data-nx-swatch]').forEach(function (b) {
      b.addEventListener('click', function () { var v = data.variants.filter(function (x) { return String(x.id) === b.dataset.nxSwatch; })[0]; if (v) setVariant(v); });
    });
    root.querySelectorAll('[data-nx-offer]').forEach(function (offer) {
      offer.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        root.querySelectorAll('[data-nx-offer]').forEach(function (o) { o.classList.toggle('is-active', o === offer); var r = o.querySelector('input[type=radio]'); if (r) r.checked = o === offer; });
      });
      offer.querySelectorAll('select[data-nx-slot]').forEach(function (s) { s.addEventListener('change', function () { s.dataset.touched = '1'; }); });
    });

    var form = root.querySelector('[data-nx-product-form]');
    if (form) form.addEventListener('submit', function (e) {
      var offer = root.querySelector('[data-nx-offer].is-active');
      if (!offer && !window.fetch) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      var items = [];
      var qty = offer ? parseInt(offer.dataset.qty, 10) || 1 : parseInt((form.querySelector('[name=quantity]') || {}).value, 10) || 1;
      var props = offer ? { _nx_offer: offer.dataset.name } : {};
      var slots = offer ? offer.querySelectorAll('select[data-nx-slot]') : [];
      if (slots.length) {
        var map = {};
        slots.forEach(function (s) { map[s.value] = (map[s.value] || 0) + 1; });
        Object.keys(map).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: map[id], properties: props }); });
      } else {
        items.push({ id: current.id, quantity: qty, properties: props });
      }
      addToCart(items, form.querySelector('[data-nx-atc]'), errorEl);
    });

    /* gallery */
  var slides = root.querySelector('[data-nx-slides]');
    var dots = root.querySelectorAll('[data-nx-dot]');
    if (slides) {
      var prev = root.querySelector('[data-nx-gprev]'), next = root.querySelector('[data-nx-gnext]');

      var go = function (dir) { slides.scrollBy({ left: dir * slides.clientWidth, behavior: 'smooth' }); };

      var update = function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        var max = slides.scrollWidth - slides.clientWidth;

        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });

        if (prev) prev.disabled = slides.scrollLeft <= 1;
        if (next) next.disabled = slides.scrollLeft >= max - 1;
      };

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      slides.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    var lb = root.querySelector('[data-nx-lightbox]');
    root.querySelectorAll('[data-nx-expand]').forEach(function (b) {
      b.addEventListener('click', function () { if (!lb || !mainImg) return; lb.querySelector('img').src = mainImg.currentSrc || mainImg.src; lb.classList.add('is-open'); lb.querySelector('button').focus(); });
    });
    if (lb) { lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('button')) lb.classList.remove('is-open'); }); document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.classList.remove('is-open'); }); }

    renderOffers();
  }

  /* ---------- Bundle builder ---------- */
  function initBundle(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var data = JSON.parse(root.querySelector('[data-nx-bundle-json]').textContent);
    var max = data.max, currency = data.currency, tiers = data.tiers.sort(function (a, b) { return a.qty - b.qty; });
    var picks = [];
    var byId = {}; data.variants.forEach(function (v) { byId[v.id] = v; });
    var errorEl = root.querySelector('[data-nx-error]');

    function perJar(n) { var p = tiers[0] ? tiers[0].price : null; tiers.forEach(function (t) { if (n >= t.qty) p = t.price; }); return p; }
    function render() {
      var n = picks.length;
      var full = picks.reduce(function (s, id) { return s + byId[id].price; }, 0);
      var pj = perJar(n);
      var total = pj != null && n ? Math.round(pj * n) : full;
      var saving = Math.max(full - total, 0);
      root.querySelectorAll('[data-nx-card]').forEach(function (card) {
        var id = parseInt(card.dataset.nxCard, 10), q = picks.filter(function (x) { return x === id; }).length;
        var st = card.querySelector('.nx-bb__stepper'); st.classList.toggle('has-qty', q > 0);
        card.querySelector('output').textContent = q;
        card.querySelector('[data-plus]').disabled = n >= max || !byId[id].available;
      });
      var slots = root.querySelectorAll('[data-nx-slot]');
      slots.forEach(function (slot, i) {
        var id = picks[i];
        slot.classList.toggle('is-filled', !!id);
        slot.innerHTML = id ? (byId[id].image ? '<img src="' + byId[id].image + '" alt="">' : '') + '<span class="nx-visually-hidden">Remove ' + byId[id].title + '</span>' : '+';
        slot.setAttribute('aria-label', id ? 'Remove ' + byId[id].title : 'Empty slot');
      });
      root.querySelector('[data-nx-count]').textContent = data.countLabel.replace('[n]', n).replace('[max]', max);
      root.querySelector('[data-nx-total]').textContent = fmt(total || 0, currency);
      root.querySelector('[data-nx-save]').textContent = saving > 0 ? data.saveLabel.replace('[saving]', fmt(saving, currency)).replace('[per]', fmt(Math.round(total / n), currency)) : '';
      var next = tiers.filter(function (t) { return t.qty > n; })[0];
      var left = next ? next.qty - n : 0;
      var nudge = data.doneLabel;
      if (n === 0 && data.startLabel) {
        nudge = data.startLabel;
      } else if (next) {
        nudge = (left === 1 && data.nudgeOneLabel ? data.nudgeOneLabel : data.nudgeLabel).replace('[left]', left).replace('[price]', fmt(next.price, currency));
      }
      root.querySelector('[data-nx-nudge]').textContent = nudge;
      root.querySelector('[data-nx-fill]').style.width = (Math.min(n / max, 1) * 100) + '%';
      root.querySelectorAll('[data-nx-tier]').forEach(function (t) { var q = parseInt(t.dataset.nxTier, 10); var reached = tiers.filter(function (x) { return x.qty <= n; }).pop(); t.classList.toggle('is-active', reached ? reached.qty === q : false); });
      var atc = root.querySelector('[data-nx-atc]'); atc.disabled = n < (data.min || 1);
    }
    root.querySelectorAll('[data-nx-card]').forEach(function (card) {
      var id = parseInt(card.dataset.nxCard, 10);
      card.querySelector('[data-plus]').addEventListener('click', function () { if (picks.length < max) { picks.push(id); render(); } });
      card.querySelector('[data-minus]').addEventListener('click', function () { var i = picks.lastIndexOf(id); if (i > -1) { picks.splice(i, 1); render(); } });
    });
    root.querySelectorAll('[data-nx-slot]').forEach(function (slot, i) { slot.addEventListener('click', function () { if (picks[i]) { picks.splice(i, 1); render(); } }); });
    root.querySelector('[data-nx-atc]').addEventListener('click', function (e) {
      e.preventDefault(); if (errorEl) errorEl.hidden = true;
      var map = {}; picks.forEach(function (id) { map[id] = (map[id] || 0) + 1; });
      var items = Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id], properties: { _nx_bundle: data.bundleName + ' (' + picks.length + ')' } }; });
      addToCart(items, e.currentTarget, errorEl);
    });
    render();
  }

  /* ---------- Timeline ---------- */
  function initTimeline(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var steps = root.querySelectorAll('[data-nx-step]');
    var imgs = root.querySelectorAll('[data-nx-step-img]');
    function activate(i) {
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      imgs.forEach(function (im, n) { im.hidden = imgs.length > 1 ? n !== i && !(n === 0 && !imgs[i]) : false; });
    }
    if (!('IntersectionObserver' in window)) { activate(0); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) activate(Array.prototype.indexOf.call(steps, en.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(function (s) { io.observe(s); });
    activate(0);
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-nx-pdp]').forEach(initPdp);
    s.querySelectorAll('[data-nx-bundle]').forEach(initBundle);
    s.querySelectorAll('[data-nx-timeline]').forEach(initTimeline);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();